module.exports = __webpack_public_path__ + "img/01-min.ffcb51cd.jpg";